export function getOptionalSelectValue(field) {
    return !!field?.value ? field.value : field;
}